// extracted by mini-css-extract-plugin
export default {"meals":"MealList_meals__owyWS","meals-appear":"MealList_meals-appear__Mlj8J","loading":"MealList_loading__EQb4h","error":"MealList_error__ra+0N"};